// extracted by mini-css-extract-plugin
export default {"wrapper":"PopoverContent_wrapper__4XYbP","row":"PopoverContent_row__mQcvB","row_name":"PopoverContent_row_name__aoxPb","row_value":"PopoverContent_row_value__XaphW"};